import { gql, useLazyQuery } from '@provision/graphql-client';
import { useCallback } from 'react';

const GET_AI_FOLLOWUP = gql`
  query GetAiFollowUp($params: GetAiFollowUpInput!) {
    getAiFollowUp(params: $params) {
      aiFollowUp
    }
  }
`;

interface GetAiFollowUpQuery {
  getAiFollowUp: {
    aiFollowUp: string;
  };
}

export const useAiEmailFollowUp = () => {
  const [getFollowUp, { ...rest }] = useLazyQuery<GetAiFollowUpQuery>(GET_AI_FOLLOWUP, {
    fetchPolicy: 'no-cache',
    context: {
      ttl: 0,
    },
  });

  const getAiFollowUp = useCallback(
    ({
      partnerId,
      userId,
      conversationId,
      transcriptionId,
      promptId,
      userCorrection,
    }: {
      partnerId: number;
      userId: string;
      conversationId: string;
      transcriptionId: string;
      promptId: string;
      userCorrection?: string;
    }) => {
      if (!promptId) {
        return;
      }
      return getFollowUp({
        variables: {
          params: {
            partnerId,
            userId,
            conversationId,
            promptId,
            transcriptionId,
            userCorrection,
          },
        },
      });
    },
    [getFollowUp],
  );

  return {
    getAiFollowUp,
    ...rest,
  };
};
